export default __webpack_public_path__ + "static/media/bendit.db9486ee.png";